var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnewayCycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 5,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-366.46625,-534.36218)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    x: 372,
    y: 534.36218,
    id: "rect3124",
    style: {
      color: "#000000",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#00ccff",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 387,536.86218 -5,-2.5 v 2 h -7 v 1 h 7 v 2 z",
    id: "path2987",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180,193.76688,269.68109)",
    id: "layer1-6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    x: 372,
    y: 534.36218,
    id: "rect3124-7",
    style: {
      color: "#000000",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#00ccff",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 387,536.86218 -5,-2.5 v 2 h -5.30815 v 1 H 382 v 2 z",
    id: "path2987-5",
    style: {
      fill: "#001bff",
      fillOpacity: 1,
      stroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnewayCycle);
export default __webpack_public_path__ + "static/media/oneway-cycle.94745864ecbb58e8925199c80d6295d8.svg";
export { ForwardRef as ReactComponent };